/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IView } from "../../../view/IView";
import { IViewInstance, VIEW_STATE } from "../../../view/ViewService";
import { offEvent, onEvent } from "@adapptio/lib-shared";

export interface TViewFetcher {
	read(): IView<unknown>;
}

export const getViewFetcher = (viewInstance: IViewInstance): TViewFetcher => {
	const promise = new Promise((resolve, reject) => {
		const handleStateChange = () => {
			if (viewInstance.state === VIEW_STATE.ERROR) {
				offEvent(viewInstance.onStateChange, handleStateChange);
				reject(viewInstance.error);
				return;
			}
			if (viewInstance.state === VIEW_STATE.READY) {
				offEvent(viewInstance.onStateChange, handleStateChange);
				resolve(viewInstance.view);
				return;
			}
		};

		onEvent(viewInstance.onStateChange, handleStateChange);
		handleStateChange();
	});

	return {
		read() {
			if (viewInstance.state === VIEW_STATE.LOADING) {
				throw promise;
			}
			if (viewInstance.state === VIEW_STATE.ERROR) {
				throw viewInstance.error;
			}
			if (viewInstance.state === VIEW_STATE.READY) {
				return viewInstance.view;
			}
		}
	};
};
